import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';

import { getErrorMessage } from '@utils/validation';

import {
  PhoneNumberInput,
  FormControl,
  TextInput,
  InputsWrapper,
  AdditionalInfo,
  SectionHeadingSmall,
} from '@common/components/forms';
import { FormContext } from '../../FormWrapper';

const SECTION_TRANSLATION_PREFIX =
  'mobile.orderForm.personalDetails.contactDetailsSection';

const ContactDetailsFormSection = () => {
  const { formik, handleChange } = useContext(FormContext);
  const { t } = useTranslation();

  const { values, handleBlur, isSubmitting, touched, errors } = formik;

  return (
    <React.Fragment>
      <SectionHeadingSmall>
        {t(`${SECTION_TRANSLATION_PREFIX}.title`, 'Kontaktangaben')}
      </SectionHeadingSmall>
      <InputsWrapper>
        <div>
          <FormControl
            hasError={touched.email && !!errors.email}
            message={touched.email && getErrorMessage(t, errors.email)}
            label={t(
              `${SECTION_TRANSLATION_PREFIX}.emailLabel`,
              'E-Mail Adresse',
            )}
          >
            <TextInput
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              hasError={touched.email && !!errors.email}
              type="email"
              inputMode="email"
              placeholder={t(
                `${SECTION_TRANSLATION_PREFIX}.emailPlaceholder`,
                'doris.mustermann@mail.ch',
              )}
              disabled={isSubmitting}
            />
          </FormControl>
          <AdditionalInfo>
            {t(
              `${SECTION_TRANSLATION_PREFIX}.emailAdditionalInfo`,
              'An diese E-Mail Adresse schicken wir Deine Rechnungen. Gib hier die selbe E-Mail Adresse an wie für Dein VIP-Konto um monatlich VIP-Punkte zu erhalten. Diese Adresse kann dafür nur einmal verwendet werden.',
            )}
          </AdditionalInfo>
        </div>
        <div>
          <FormControl
            hasError={
              touched.contact_phone_number_field &&
              !!errors.contact_phone_number
            }
            message={
              touched.contact_phone_number_field &&
              getErrorMessage(t, errors.contact_phone_number)
            }
            label={t(
              `${SECTION_TRANSLATION_PREFIX}.contactPhoneLabel`,
              'Mobile',
            )}
            noSpacingBottom
          >
            <PhoneNumberInput
              name="contact_phone_number"
              value={values.contact_phone_number}
              onBlur={handleBlur}
              prefixFieldName="contact_phone_number_prefix"
              numberFieldName="contact_phone_number_field"
              prefixFieldId="contact_phone_number_prefix"
              numberFieldId="contact_phone_number_field"
              setFieldValue={(name, value) =>
                handleChange({
                  target: { name, value },
                })
              }
              hasError={
                touched.contact_phone_number_field &&
                !!errors.contact_phone_number
              }
              disabled={isSubmitting}
              withSpacing
            />
          </FormControl>
          <AdditionalInfo>
            {t(
              `${SECTION_TRANSLATION_PREFIX}.contactPhoneAdditionalInfo`,
              ' Unter dieser Nummer kontaktieren wir Dich, falls Probleme auftauchen sollten.',
            )}
          </AdditionalInfo>
        </div>
      </InputsWrapper>
    </React.Fragment>
  );
};

export default ContactDetailsFormSection;
